import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Component from '../../components/js/modules/SearchBox';
import { actions, ISearchConditionsState } from '../../../../common/store/search/searchConditions';

interface GlobalState {
  searchConditions?: ISearchConditionsState;
}

const SearchBox = (): JSX.Element => {
  const dispatch = useDispatch();

  const query = useSelector((state: GlobalState) => state.searchConditions?.query ?? '');
  const suggestList = useSelector((state: GlobalState) => state.searchConditions?.suggestList) ?? [];

  const fetchSearchSuggestion = useCallback(
    (keyword: string) => {
      dispatch(actions.fetchSearchSuggestion(keyword));
    },
    [dispatch]
  );

  return <Component query={query} suggestList={suggestList} fetchSearchSuggestion={fetchSearchSuggestion} />;
};

export default SearchBox;
